import { PaginatedCollection, directusApi } from '@/api';

export interface Brand {
    id?: number;
    name?: string;
    parent_id?: number;
    slug?: string;
    image?: any;
    is_featured?: boolean;
    cover:any;
    products: Array<any>;
}

export interface BrandState {
    activeBrand: Brand | null;
    activeBrandLoading: boolean;

    allBrands: Array<Brand>;
    allBrandsLoading: boolean;
    brandsPerPage: number;
    brandsPage: number;
    brandsTotal: number;
}

const defaultBrand = {
    id: 0,
    name: '',
    parent_id: null,
    slug: '',
    image: null,
    is_featured: false,
    cover:null,
    products: [],
};

const state: BrandState = {
    activeBrand: {
        id: 0,
        name: '',
        parent_id: null,
        slug: '',
        image: null,
        is_featured: false,
        cover:null,
        products: [],
    },
    activeBrandLoading: false,

    allBrands: [],
    allBrandsLoading: false,
    brandsPerPage: 1,
    brandsPage: 1,
    brandsTotal: 1,
};

const mutations = {
    toggleallBrandsLoading(state: BrandState, data: boolean) {
        state.allBrandsLoading = data;
    },
    setAllBrands(state: BrandState, data: PaginatedCollection) {
        state.allBrands = data.items;
        state.brandsPerPage = data.perPage;
        state.brandsPage = data.currentPage;
        state.brandsTotal = data.totalItems;
        
    },
    toggleActiveBrandLoading(state: BrandState, data: boolean) {
        state.activeBrandLoading = data;
    },
    setActiveBrand(state: BrandState, data: Brand) {
        state.activeBrand = data;
    },
};

const actions = {
    async getAll( { _, commit }: any, {search,page}: any) {
        commit('toggleallBrandsLoading', true);
        let endpoint = `items/products_brands`;

        await directusApi('GET', endpoint)
            .then(res => {
                commit('setAllBrands', {
                    items: res.data.data,
                    currentPage: page,
                });
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                commit('toggleallBrandsLoading', false);
            });
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
